<template>
    <div class="card m-3 shadow">

        <!--cabezera-->
        <div class="card-header">

            <div class="d-flex">
                <div class="flex-fill">
                    <SearchUser></SearchUser>
                </div>

                <div class="float-end">
                    <PaginationUser></PaginationUser>
                </div>

            </div>

        </div>

        <!--cuerpo-->
        <div class="card-body">

            <TableUser></TableUser>

        </div>
    </div>
</template>
<script>
import TableUser from './UserList/Table-user.vue'
import PaginationUser from '@/components/UserMaintainer/UserList/Pagination-user.vue'
import SearchUser from './UserList/Search-user.vue'

export default {
    name: 'UserList',

    components: {
        TableUser,
        PaginationUser,
        SearchUser
    }
}
</script>
<style></style>